import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"200px"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-4 referral-col small text-muted text-capitalize-first" }
const _hoisted_4 = { class: "col-sm-4 referral-col small text-muted text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-4 referral-col small text-muted text-capitalize-first" }
const _hoisted_6 = { class: "col-sm-4 referral-col" }
const _hoisted_7 = { class: "col-sm-4 referral-col" }
const _hoisted_8 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "col-sm-4 referral-col" }
const _hoisted_11 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "d-block text-muted mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "dialog-class": "modal-lg",
    title: _ctx.helper.trans('labels.referral_store_fees'),
    modelValue: _ctx.modal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalErrors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.message,
            class: "alert alert-danger mt-2 mb-0"
          }, _toDisplayString(error.message), 1))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.referral')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.pay_in_reward_fee_percent')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.pay_out_reward_fee_percent')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row mb-3 align-items-start",
            key: row.slot
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.errorsFor(row.slot, 'referralId')
              }, {
                default: _withCtx((parentProps) => [
                  _createVNode(_component_Multiselect, {
                    class: _normalizeClass(parentProps.class),
                    "model-value": row.referralUser,
                    "track-by": "id",
                    options: _ctx.referrals,
                    "custom-label": (opt) => `${opt.name} (${opt.email})`,
                    "select-label": "Select",
                    "deselect-label": "✕",
                    placeholder: _ctx.helper.trans('labels.referral_store_override_placeholder'),
                    "open-direction": "bottom",
                    multiple: false,
                    searchable: true,
                    "internal-search": true,
                    "clear-on-select": false,
                    "close-on-select": true,
                    "options-limit": 100,
                    limit: 1000,
                    "show-no-results": false,
                    "hide-selected": false,
                    onSearchChange: _ctx.asyncFindReferrals,
                    onSelect: (user) => _ctx.onSelectReferral(row, user),
                    onRemove: () => _ctx.onRemoveReferral(row),
                    loading: _ctx.isReferralsSelectLoading
                  }, null, 8, ["class", "model-value", "options", "custom-label", "placeholder", "onSearchChange", "onSelect", "onRemove", "loading"])
                ]),
                _: 2
              }, 1032, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.errorsFor(row.slot, 'payInFee')
              }, {
                default: _withCtx((parentProps) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group input-group-sm", parentProps.class])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((row.payInFee) = $event),
                      type: "text",
                      class: "form-control",
                      "data-maska": "99.99",
                      "data-maska-tokens": "9:[0-9]:optional",
                      placeholder: String(row.merchantPayInFee)
                    }, null, 8, _hoisted_8), [
                      [_vModelText, row.payInFee],
                      [_directive_maska]
                    ]),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.toggleReferralFeeType(row, 'payIn')), ["prevent"]),
                      class: "btn btn-outline-secondary",
                      type: "button"
                    }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${row.payInFeeType}`)), 9, _hoisted_9)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_FormInputWrapper, {
                errors: _ctx.errorsFor(row.slot, 'payOutFee')
              }, {
                default: _withCtx((parentProps) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["input-group input-group-sm", parentProps.class])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((row.payOutFee) = $event),
                      type: "text",
                      class: "form-control",
                      "data-maska": "99.99",
                      "data-maska-tokens": "9:[0-9]:optional",
                      placeholder: String(row.merchantPayOutFee)
                    }, null, 8, _hoisted_11), [
                      [_vModelText, row.payOutFee],
                      [_directive_maska]
                    ]),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.toggleReferralFeeType(row, 'payOut')), ["prevent"]),
                      class: "btn btn-outline-secondary",
                      type: "button"
                    }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${row.payOutFeeType}`)), 9, _hoisted_12)
                  ], 2)
                ]),
                _: 2
              }, 1032, ["errors"])
            ])
          ]))
        }), 128)),
        _createElementVNode("small", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.referral_store_fees_hint')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = false)),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.apply())),
        class: "btn btn-outline-primary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}